import { render } from "./Months.vue?vue&type=template&id=6dad0e60"
import script from "./Months.vue?vue&type=script&lang=ts"
export * from "./Months.vue?vue&type=script&lang=ts"
script.render = render

export default script